import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fb9e1d0e")

_pushScopeId("data-v-fb9e1d0e")
const _hoisted_1 = { class: "mb-8" }
const _hoisted_2 = { class: "font-size-18 font-bold mb-1" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "bg-gray-196 w-full h-12"
}
const _hoisted_10 = {
  key: 0,
  class: "text-center"
}
const _hoisted_11 = {
  key: 1,
  class: "bg-gray-196 w-full h-12"
}
const _hoisted_12 = {
  key: 0,
  class: "text-center"
}
const _hoisted_13 = {
  key: 1,
  class: "bg-gray-196 w-full h-12"
}
const _hoisted_14 = {
  key: 1,
  class: "mt-10"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Select = _resolveComponent("Select")
  const _component_Table = _resolveComponent("Table")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('workPatternSetting')), 1),
    _hoisted_3,
    (_ctx.workingStyleMasterParams.way_of_working === _ctx.WAY_OF_WORKING.FIXED)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode(_component_Table, {
            class: "w-full",
            data: _ctx.workingStyleData,
            headers: _ctx.workingStyleHeaders
          }, {
            day_of_week: _withId(({ item }) => [
              _createVNode("div", _hoisted_5, _toDisplayString(item.day_of_week), 1)
            ]),
            setting_working_day: _withId(({ index }) => [
              _createVNode("div", _hoisted_6, [
                _createVNode(_component_Select, {
                  required: "",
                  class: "text-center",
                  "options-select": _ctx.workTypeList,
                  placeholder: _ctx.t('placeholderSelect'),
                  modelValue: 
                _ctx.workingStyleMasterParams.working_style_schedule_weeks[index]
                  .setting_working_day
              ,
                  "onUpdate:modelValue": ($event: any) => (
                _ctx.workingStyleMasterParams.working_style_schedule_weeks[index]
                  .setting_working_day
               = $event),
                  validated: _ctx.validated,
                  errors: 
                _ctx.errorsData[
                  `working_style_schedule_weeks.${index}.
                  .setting_working_day`
                ]
              ,
                  "onUpdate:errors": ($event: any) => (
                _ctx.errorsData[
                  `working_style_schedule_weeks.${index}.
                  .setting_working_day`
                ]
               = $event),
                  "item-value": "key",
                  "item-text": "value"
                }, null, 8, ["options-select", "placeholder", "modelValue", "onUpdate:modelValue", "validated", "errors", "onUpdate:errors"])
              ])
            ]),
            work_patter: _withId(({ index }) => [
              _createVNode("div", _hoisted_7, [
                (
                _ctx.workingStyleMasterParams.working_style_schedule_weeks[index]
                  .setting_working_day === _ctx.SETTING_WORKING_DAY_TYPE.WEEKDAYS
              )
                  ? (_openBlock(), _createBlock("div", _hoisted_8, [
                      _createVNode(_component_Select, {
                        required: 
                  _ctx.workingStyleMasterParams.working_style_schedule_weeks[index]
                    .setting_working_day === _ctx.SETTING_WORKING_DAY_TYPE.WEEKDAYS
                ,
                        errors: 
                  _ctx.errorsData[
                    `working_style_schedule_weeks.${index}.
                  .shift_pattern_id`
                  ]
                ,
                        "onUpdate:errors": ($event: any) => (
                  _ctx.errorsData[
                    `working_style_schedule_weeks.${index}.
                  .shift_pattern_id`
                  ]
                 = $event),
                        validated: _ctx.validated,
                        placeholder: _ctx.t('placeholderSelect'),
                        "options-select": _ctx.shiftPatternData,
                        "item-text": "shift_pattern_name",
                        "item-value": "shift_pattern_id",
                        modelValue: 
                  _ctx.workingStyleMasterParams.working_style_schedule_weeks[index]
                    .shift_pattern_id
                ,
                        "onUpdate:modelValue": ($event: any) => (
                  _ctx.workingStyleMasterParams.working_style_schedule_weeks[index]
                    .shift_pattern_id
                 = $event)
                      }, null, 8, ["required", "errors", "onUpdate:errors", "validated", "placeholder", "options-select", "modelValue", "onUpdate:modelValue"])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_9))
              ])
            ]),
            working_hours: _withId(({ index }) => [
              (
              _ctx.workingStyleMasterParams.working_style_schedule_weeks[index]
                .setting_working_day === _ctx.SETTING_WORKING_DAY_TYPE.WEEKDAYS
            )
                ? (_openBlock(), _createBlock("div", _hoisted_10, _toDisplayString(_ctx.displayShiftPatternWorkingHour(
                _ctx.workingStyleMasterParams.working_style_schedule_weeks[index]
                  .shift_pattern_id
              )), 1))
                : (_openBlock(), _createBlock("div", _hoisted_11))
            ]),
            break: _withId(({ index }) => [
              (
              _ctx.workingStyleMasterParams.working_style_schedule_weeks[index]
                .setting_working_day === _ctx.SETTING_WORKING_DAY_TYPE.WEEKDAYS
            )
                ? (_openBlock(), _createBlock("div", _hoisted_12, _toDisplayString(_ctx.displayShiftPatternBreak(
                _ctx.workingStyleMasterParams.working_style_schedule_weeks[index]
                  .shift_pattern_id
              )), 1))
                : (_openBlock(), _createBlock("div", _hoisted_13))
            ]),
            _: 1
          }, 8, ["data", "headers"])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_14, _toDisplayString(_ctx.t('theWorkingHoursOfRegisteredShiftValid')), 1))
  ]))
})